import { Box, Button, Center, HStack, VStack } from '@chakra-ui/react';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useAppDispatch, useTypedSelector } from '../../../../hooks/store';

import {
  changeStatusOpenRegisterDevice,
  changeStatusRegisterDevice,
  resetDataOwnDeviceByESN,
  selectDataOwnDeviceByESN,
  selectSkyTrakCode,
} from '../../../../slices/skytrak';
import { selectUserData } from '../../../../slices/user';

const ContentConfirmESN = () => {
  const intl = useIntl();
  const dispatch = useAppDispatch();
  const dataOwnDeviceByESN = useTypedSelector(selectDataOwnDeviceByESN);
  const skyTrakCode = useTypedSelector(selectSkyTrakCode);
  const skyTrakUser = useTypedSelector(selectUserData);

  const onClose = useCallback(() => {
    dispatch(changeStatusOpenRegisterDevice(false));
    dispatch(resetDataOwnDeviceByESN());
    dispatch(changeStatusRegisterDevice('invalidESN'));
  }, [dispatch]);

  const confirmESN = useCallback(() => {
    if (skyTrakCode !== 0) {
      dispatch(changeStatusRegisterDevice('notCorrectAccount'));
    } else if (
      skyTrakUser &&
      dataOwnDeviceByESN &&
      dataOwnDeviceByESN.customerOwnDevice &&
      dataOwnDeviceByESN.customerOwnDevice.email !== skyTrakUser.email
    ) {
      dispatch(changeStatusRegisterDevice('deactivateAccount'));
    } else {
      dispatch(changeStatusRegisterDevice('selectPlan'));
    }
  }, [dataOwnDeviceByESN, dispatch, skyTrakCode, skyTrakUser]);

  return (
    <>
      <VStack
        background={'#FFF'}
        rounded={12}
        padding={{ mobile: '16px', sm: '24px' }}
        gap={{ mobile: '16px' }}
        alignItems={{ mobile: 'flex-start' }}
        width={'100%'}
      >
        <VStack
          gap={{ mobile: '16px' }}
          alignItems={{ mobile: 'flex-start' }}
          width={{ mobile: 'calc(100% - 120px)' }}
        >
          <Box
            fontSize={17}
            lineHeight={'24px'}
            letterSpacing={'0.25px'}
            fontWeight={700}
            color={'#36383E'}
          >
            {intl.formatMessage({ id: 'confirmESN' })}
          </Box>
          <Box fontSize={14} lineHeight={'20px'} color={'#36383E'}>
            {intl.formatMessage({ id: 'confirmESNSub' })}
          </Box>
        </VStack>

        <Center
          background={'#F4F5F6'}
          rounded={12}
          w={'100%'}
          padding={{ mobile: '16px' }}
        >
          <Box
            fontSize={24}
            lineHeight={'28px'}
            letterSpacing={'0.3em'}
            color={'#36383E'}
            fontWeight={700}
          >
            {dataOwnDeviceByESN?.device.esn}
          </Box>
        </Center>
        <Box>
          <Box fontSize={14} lineHeight={'20px'} color={'#36383E'}>
            {intl.formatMessage({ id: 'confirmESNDes2' })}
          </Box>
          <Box fontSize={14} lineHeight={'20px'} color={'#36383E'}>
            {intl.formatMessage({ id: 'confirmESNQuestion' })}
          </Box>
        </Box>
      </VStack>
      <HStack spacing={'16px'} justifyContent={'center'} mt={'24px'} w={'100%'}>
        <Button
          variant={'semiGraySkyTrak'}
          fontSize={13}
          lineHeight={'18px'}
          letterSpacing={'0.25px'}
          h={'32px'}
          minW={'160px'}
          onClick={onClose}
        >
          {intl.formatMessage({ id: 'confirmESNNo' })}
        </Button>
        <Button
          variant={'secondarySkyTrak'}
          fontSize={13}
          lineHeight={'18px'}
          letterSpacing={'0.25px'}
          h={'32px'}
          minW={'160px'}
          onClick={confirmESN}
        >
          {intl.formatMessage({ id: 'confirmESNYes' })}
        </Button>
      </HStack>
    </>
  );
};

export default ContentConfirmESN;
